module.exports = "/_next/static/images/fenxiaoguanli-0fcaee3ec02bc091d5d1598058e1ed11.png";